import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { Step } from "../types";
import { createStepsMap } from "./createStepsMap";

/**
 * Gets current step details based on the URL pathname.
 *
 * @returns step object
 */
export const useCurrentStepDetails = <PathType>(
  steps: Step<PathType>[],
  rootStepPath: string
) => {
  const location = useLocation();
  const stepsMap = useMemo(() => createStepsMap(steps), [steps]);

  const mapPathnameToStep = (pathname: string): Step<PathType> => {
    if (pathname === "/") return stepsMap[rootStepPath] ?? stepsMap["*"];
    const stepName = pathname.replace("/", "");

    return stepsMap[stepName];
  };

  return useMemo(
    () => mapPathnameToStep(location.pathname),
    [location.pathname]
  );
};
